import { createUseStyles } from 'react-jss'
import { zIndex5 } from '../../../../../../../styles/const/common'

export const cubicBezier = 'cubic-bezier(0.22, 0.61, 0.36, 1)'

const useStyles = createUseStyles({
  loader: {
    width: 50
  },
  playPauseButtons: {
    opacity: 0,
    transition: `opacity 600ms ${cubicBezier}`
  },
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: zIndex5,

    '&:hover': {
      '& $playPauseButtons': {
        opacity: 1
      }
    }
  },
  icon: {
    cursor: 'pointer',
    opacity: 0.9,
    color: 'white',
    '& svg': {
      width: '50px',
      height: '50px',
      '& path': {
        color: 'white'
      }
    }
  }
})

export default useStyles
